import lib from "./lib/lib.js";
import Player from "@vimeo/player";

/** Safari Solution: Create a new overlay that controls the video on Click and DBLCLick **/
const Vimeo = {
  init: (state) => {
    if (!state.vimeo) {
      state.vimeo = {};
    } else {
      Object.values(state.vimeo).forEach((v) => {
        if (v.player) {
          v.player.destroy();
        }
      });
    }

    const loadVideo = (prop) => {
      if (window.innerWidth <= 680) {
        prop.player = new Player(prop.obj, {
          id: prop.obj.dataset.vimeomobile,
          playsinline: true,
          muted: prop.mute,
          controls: false,
          byline: false,
          autoplay: prop.play,
          responsive: true,
          pip: false,
          background: prop.background,
        });
      } else {
        if (prop.obj.dataset.vimeoDark && state.theme.current == "dark") {
          // console.log("dark mode vimeo: " + prop.obj.dataset.vimeoDark);
          prop.player = new Player(prop.obj, {
            id: prop.obj.dataset.vimeoDark,
            playsinline: true,
            muted: prop.mute,
            controls: false,
            byline: false,
            autoplay: prop.play,
            responsive: true,
            pip: false,
            background: prop.background,
          });
        } else {
          prop.player = new Player(prop.obj, {
            id: prop.obj.dataset.vimeo,
            playsinline: true,
            muted: prop.mute,
            controls: false,
            byline: false,
            autoplay: prop.play,
            responsive: true,
            pip: false,
            background: prop.background,
          });
        }
      }

      prop.player.ready().then(() => {
        // The Player is Ready
        //setTimeout(() => {
        prop.root.classList.add("is-ready");
        prop.root.dataset.loaded = true;
        //}, 0);
      });

      // videoSize();

      prop?.playObj?.addEventListener("click", (e) => {
        prop.play = !prop.play;
        Vimeo.render(prop);
      });

      prop?.muteObj?.addEventListener("click", (e) => {
        prop.mute = !prop.mute;
        Vimeo.render(prop);
      });

      prop?.expandObj?.addEventListener("click", (e) => {
        prop.screen = !prop.screen;
        Vimeo.render(prop);
      });

      let bar = lib.qs(".bar .progress", prop.root);
      let barroot = lib.qs(".bar-progress", prop.root);

      prop?.obj?.addEventListener("click", (e) => {
        //e.stopPropagation();
        prop.play = !prop.play;
        Vimeo.render(prop);
      });

      prop?.obj?.addEventListener("dblclick", (e) => {
        //e.stopPropagation();
        prop.screen = !prop.screen;
        Vimeo.render(prop);
      });

      barroot?.addEventListener("mouseenter", (e) => {
        prop.barhover = true;
      });

      let timeout = "";

      // TIMEOUT (Faded Banner)
      prop?.root?.addEventListener("mousemove", (e) => {
        prop.root.classList.remove("fadeout");
        clearTimeout(timeout);

        timeout = setTimeout(() => {
          prop.root.classList.add("fadeout");
        }, 1000);
      });

      prop?.root?.addEventListener("mouseleave", (e) => {
        prop.root.classList.remove("fadeout");
        clearTimeout(timeout);
      });
      // END TIMEOUT (Faded Banner)

      if (bar) {
        barroot?.addEventListener("mousemove", (e) => {
          bar.style.width = (e.offsetX * 100) / barroot.offsetWidth + "%";
        });

        barroot?.addEventListener("click", (e) => {
          let barduration = (e.offsetX * 100) / barroot.offsetWidth;

          prop.play = true;
          Vimeo.render(prop);

          prop.player.getDuration().then((duration) => {
            prop.player
              .setCurrentTime((barduration / 100) * duration)
              .then(function (seconds) {});
          });
          // prop.player.currentTime = (duration / 100) * prop.player.duration;
        });

        barroot?.addEventListener("mouseleave", (e) => {
          prop.barhover = false;
        });

        setInterval(() => {
          if (prop?.barhover === false) {
            prop.player.getDuration().then((duration) => {
              prop.player.getCurrentTime().then(function (seconds) {
                let percentage = (seconds * 100) / duration;
                bar.style.width = percentage + "%";
              });
            });

            // if (percentage === 100) {
            //   prop.player.currentTime = 0;
            //   prop.play = false;
            //   Vimeo.render(prop);
            // }
          }
        }, 50);
      }

      Vimeo.render(prop);
    };

    const initialLoad = () => {
      // Set up Prop Objects
      lib.qsa(".inline-vimeo").forEach((root, i) => {
        let prop = (state.vimeo[i] = {});

        prop.root = root;
        prop.playObj = lib.qs(".play-pause", prop.root);
        prop.muteObj = lib.qs(".mute-unmute", prop.root);
        prop.expandObj = lib.qs(".expand-subtract", prop.root);
        prop.obj = lib.qs(".vimeo-player", prop.root); // Vimeo Player Object Selected
        prop.autoplay = prop.obj.getAttribute("autoplay") === "" ? true : false;
        prop.play = prop.obj.getAttribute("autoplay") === "" ? true : false;
        prop.mute = prop.obj.getAttribute("autoplay") === "" ? true : false;
        prop.background =
          prop.obj.getAttribute("autoplay") === "" ? true : false;
        prop.screen = false;
        prop.barhover = false;
      });
    };

    // Check if the video is loaded, and in view
    const checkLoaded = () => {
      lib.qsa(".inline-vimeo").forEach((root, i) => {
        let prop = state.vimeo[i];

        // Check that object exists
        if (prop) {
          // If not in viewport
          if (!lib.inViewportClassic(root) && prop.loaded === true) {
            if (prop.autoplay === true) {
              if (prop.play === true) {
                prop.play = false;
                Vimeo.render(prop);
              }
            }
          }

          if (lib.inViewportClassic(root) && prop.loaded === true) {
            if (prop.autoplay === true) {
              if (prop.play === false) {
                prop.play = true;
                Vimeo.render(prop);
              }
            }
          }
        }

        if (lib.isNearViewport(root) && !prop.loaded) {
          loadVideo(prop);
          prop.loaded = true;
        }
      });
    };

    initialLoad();
    checkLoaded();

    setTimeout(() => {
      window.onscroll = () => {
        checkLoaded();
      };
    }, 800);
  },
  render: (prop) => {
    prop.player.play();

    if (prop.play) {
      prop.player.play();
    } else {
      prop.player.pause();
    }

    if (prop.playObj) {
      prop.playObj.dataset.status = prop.play;
    }
    prop.root.dataset.status = prop.play;

    prop.player.muted = prop.mute;
    if (prop.muteObj) {
      prop.muteObj.dataset.status = prop.mute;
    }

    prop.player.screen = prop.screen;
    if (prop.expandObj) {
      prop.expandObj.dataset.status = prop.screen;
    }
    prop.root.dataset.fullscreen = prop.screen;

    if (prop.screen === true) {
      // Request Full Screen
      if (prop.root.requestFullscreen) prop.root.requestFullscreen();
      else if (prop.root.webkitRequestFullscreen)
        prop.root.webkitRequestFullscreen();
      else if (prop.root.msRequestFullScreen) prop.root.msRequestFullScreen();
    }

    if (prop.screen === false) {
      // if (document.exitFullscreen) {
      //   document.exitFullscreen();
      // } else if (document.webkitExitFullscreen) {
      //   /* Safari */
      //   document.webkitExitFullscreen();
      // } else if (document.msExitFullscreen) {
      //   /* IE11 */
      //   document.msExitFullscreen();
      // }
    }
  },
};

export { Vimeo as default };
